import React, { useMemo, useState } from "react";
import {
  Select,
  Button,
  MyMessage,
  InputField,
  AddPageShell,
  AddSection,
} from "../../components/Component";
import { useDoSeeDataContext } from "../../../context/DoSeeDataContext";
import { FOLDERS, image_kit_folder } from "../utils/Utils";
import { defaultImage } from "../../../lib/libraries/imageKit/ImageKit";
import { ImageKitUpload } from "../../../ui/ImageKitLibrary";
import ModalDetails from "../utils/hotelRestauDetails/ModalDetails";
import ExteriorImages from "./exteriorImages";
import { useGeoPositionContext } from "../utils/geoPosition";
import { _TYPES_ } from "../utils/types";
import Pricing from "../../components/Pricing";
import GenerateDescription from "../utils/GenerateDescription";
import {
  ContactSection,
  SocialSection,
  GeoSection,
  VisibilitySection,
  DescriptionSection,
} from "../utils/AddSections";
import { FiImage, FiDollarSign, FiPlus, FiStar } from "react-icons/fi";
import { FaHotel } from "react-icons/fa";

const slugify = (str: any) =>
  (str || "")
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)+/g, "");

const Add = () => {
  const { createOneContent } = useDoSeeDataContext();
  const {
    country_id,
    entry_label,
    country_name,
    first_level_id,
    fourth_level_id,
    second_level_id,
    third_level_id,
    tags,
  } = useGeoPositionContext();

  const [thumbnail, setThumbnail] = useState(defaultImage);
  const [thumbnailId, setThumbnailId] = useState("img_cdn_id");
  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const [title, setTitle] = useState("");
  const [venue, setVenue] = useState("");
  const [rating, setRating] = useState<any>("");

  const [fee, setFee] = useState(0);
  const [vip, setVip] = useState(0);
  const [vvip, setVvip] = useState(0);

  const [email, setEmail] = useState("");
  const [payLink, setPayLink] = useState<any>(null);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [whatsapp, setWhatsapp] = useState("none");
  const [facebook, setFacebook] = useState("none");
  const [twitter, setTwitter] = useState("none");
  const [instagram, setInstagram] = useState("none");
  const [youtube, setYoutube] = useState("none");

  const [hashtags, setHashtags] = useState("");
  const [googleMapCode, setGoogleMapCode] = useState("none");
  const [latitude, setLatitude] = useState("none");
  const [longitude, setLongitude] = useState("none");
  const [formattedAddress, setFormattedAddress] = useState("");

  const [featured, setFeatured] = useState<any>("no");
  const [promoted, setPromoted] = useState<any>("no");
  const [hotelStatus, setHotelStatus] = useState(1);

  const [description, setDescription] = useState("");
  const [collection, setCollection] = useState<any[]>([]);
  const [exteriorImages, setExteriorImages] = useState<any[]>([]);

  const [showModal, setShowModal] = useState(false);
  const [showExtImages, setShowExtImages] = useState(false);
  const [expo, setExpo] = useState(0);
  const [showTop, setShowTop] = useState(0);
  const [pricing, setPricing] = useState<any[]>([]);
  const [showDescriptionModal, setShowDescriptionModal] = useState(false);

  const hotelRoutes = "/data/hotel";

  const clearAlerts = () => {
    setError(false);
    setSuccess(false);
    setErrorMessage("");
  };

  const cleanFields = () => {
    setLoading(false);
    setSuccess(true);
    setThumbnail(defaultImage);
    setThumbnailId("img_cdn_id");

    setTitle("");
    setVenue("");
    setRating("");

    setFee(0);
    setVip(0);
    setVvip(0);

    setEmail("");
    setPayLink(null);
    setPhoneNumber("");
    setWhatsapp("none");
    setFacebook("none");
    setTwitter("none");
    setInstagram("none");
    setYoutube("none");

    setHashtags("");
    setGoogleMapCode("none");
    setLatitude("none");
    setLongitude("none");
    setFormattedAddress("");

    setFeatured("no");
    setPromoted("no");
    setHotelStatus(1);

    setDescription("");
    setCollection([]);
    setExteriorImages([]);
    setShowTop(0);
    setExpo(0);
    setPricing([]);
  };

  const responses = (isError: any, msg: any) => {
    setError(isError);
    setLoading(false);
    setSuccess(!isError);
    setErrorMessage(msg || "");
  };

  const isValid = useMemo(() => {
    return Boolean(country_id && title?.trim() && thumbnail && thumbnailId);
  }, [country_id, title, thumbnail, thumbnailId]);

  const addOneHotelHandler = async (e: any) => {
    e.preventDefault();
    clearAlerts();
    setLoading(true);

    if (!isValid) {
      responses(
        true,
        !country_id
          ? "Select a country/position first"
          : "Image and Title are required"
      );
      return;
    }

    await sendDBRequest();
  };

  const sendDBRequest = async () => {
    const data = {
      country_id: country_id,
      first_level_id: first_level_id ? first_level_id : 0,
      second_level_id: second_level_id ? second_level_id : 0,
      third_level_id: third_level_id ? third_level_id : 0,
      fourth_level_id: fourth_level_id ? fourth_level_id : 0,
      title: title,
      slug: title ? slugify(title) : null,
      description: description,
      venue: venue,
      rating: rating,
      fee: fee,
      vip: vip,
      vvip: vvip,
      thumbnail: thumbnail ? thumbnail : defaultImage,
      image_cdn_id: thumbnailId ? thumbnailId : "",
      phone_number: phoneNumber,
      email_address: email,
      pay_link: payLink,
      whatsapp: whatsapp,
      facebook: facebook,
      twitter: twitter,
      instagram: instagram,
      youtube: youtube,
      hashtag: `${tags || ""}${tags ? ", " : ""}${hashtags || ""}`,
      audio_adv: "none",
      google_map_code: googleMapCode,
      latitude: latitude,
      longitude: longitude,
      formatted_address: formattedAddress,
      country_short: "none",
      status: hotelStatus,
      featured: featured,
      promoted: promoted,
      subdata: collection?.length > 0 ? collection : [],
      expo: expo,
      show_top: showTop,
      exterior_images: exteriorImages?.filter((x: any) => x?.thumbnail !== null),
      pricing: pricing,
    };

    const { status, message } = await createOneContent({
      data,
      content: _TYPES_.HOTEL,
    });

    if (status === 200 || status === 201) {
      cleanFields();
      responses(false, message);
    } else {
      responses(true, message);
    }
  };

  return (
    <AddPageShell
      backRoute={hotelRoutes}
      eyebrow="DoSee Data • Hotels"
      title="Add Hotel"
      subtitle={`List a hotel, resort or stay in ${entry_label || "this destination"}.`}
      icon={<FaHotel className="h-5 w-5" />}
      pills={
        country_name ? [{ label: "Country", value: country_name }] : undefined
      }
      modals={
        <>
          {showDescriptionModal ? (
            <GenerateDescription
              setDescription={setDescription}
              setShowDescriptionModal={setShowDescriptionModal}
            />
          ) : null}
          <ModalDetails
            onClick={() => setShowModal(false)}
            showModal={showModal}
            collection={collection}
            setCollection={setCollection}
          />
          <ExteriorImages
            exteriorImages={exteriorImages}
            setExteriorImages={setExteriorImages}
            showModal={showExtImages}
            onClick={() => setShowExtImages(false)}
          />
        </>
      }
      loading={loading}
      submitLabel="Add Hotel"
      submitHelper={isValid ? "Ready to submit" : "Provide a title and cover image"}
      onSubmit={addOneHotelHandler}
      onSubmitClick={clearAlerts}
      message={
        <MyMessage
          error={error}
          message={message}
          success={success}
          onExpired={clearAlerts}
          onClick={clearAlerts}
        />
      }
    >
      <AddSection
        title="Cover Image"
        hint="Upload a high-quality thumbnail. JPG/PNG recommended."
        icon={<FiImage className="h-4 w-4" />}
      >
        <ImageKitUpload
          thumbnail={thumbnail}
          thumbnailId={thumbnailId}
          setThumbnail={setThumbnail}
          setThumbnailId={setThumbnailId}
          folder={image_kit_folder(country_name, FOLDERS.HOTELS)}
        />
      </AddSection>

      <AddSection title="Hotel Details" hint="Name, area, rating and address.">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
          <InputField
            props={{
              id: "title",
              title: "Title",
              type: "text",
              required: true,
              value: title,
              placeholder: "e.g., LakeView Resort & Spa",
              onChange: (e: any) => setTitle(e.target.value),
            }}
          />
          <Select
            props={{
              id: "top",
              title: "Show In Top Hotels",
              option: ["no", "yes"],
              onChange: (e: any) =>
                setShowTop(e.target.value === "yes" ? 1 : 0),
            }}
          />
          <InputField
            props={{
              id: "venue",
              title: "Venue",
              type: "text",
              value: venue,
              placeholder: "Neighborhood / Area",
              onChange: (e: any) => setVenue(e.target.value),
            }}
          />
          <InputField
            props={{
              id: "formatted_address",
              title: "Formatted Address",
              type: "text",
              value: formattedAddress,
              placeholder: "Street, City, Region",
              onChange: (e: any) => setFormattedAddress(e.target.value),
            }}
          />
          <InputField
            props={{
              id: "rating",
              title: "Rating",
              type: "number",
              value: String(rating || ""),
              placeholder: "e.g., 4.5",
              onChange: (e: any) => setRating(e.target.value),
            }}
          />
        </div>
        <p className="mt-2 text-xs text-gray-500">
          Slug preview:{" "}
          <span className="font-mono">{slugify(title) || "(auto)"}</span>
        </p>
      </AddSection>

      <AddSection
        title="Pricing"
        hint="Optional pricing tiers."
        icon={<FiDollarSign className="h-4 w-4" />}
      >
        <Pricing pricing={pricing} setPricing={setPricing} />
      </AddSection>

      <ContactSection
        phone={phoneNumber}
        setPhone={setPhoneNumber}
        email={email}
        setEmail={setEmail}
        payLink={payLink}
        setPayLink={setPayLink}
      />

      <SocialSection
        whatsapp={whatsapp}
        setWhatsapp={setWhatsapp}
        facebook={facebook}
        setFacebook={setFacebook}
        twitter={twitter}
        setTwitter={setTwitter}
        instagram={instagram}
        setInstagram={setInstagram}
        youtube={youtube}
        setYoutube={setYoutube}
      />

      <GeoSection
        googleMapCode={googleMapCode}
        setGoogleMapCode={setGoogleMapCode}
        latitude={latitude}
        setLatitude={setLatitude}
        longitude={longitude}
        setLongitude={setLongitude}
      />

      <VisibilitySection
        statusId="hotel_status"
        setStatus={setHotelStatus}
        setFeatured={setFeatured}
        setPromoted={setPromoted}
        setExpo={setExpo}
      />

      <AddSection
        title="Galleries & Extras"
        hint="Optional interior/exterior photos and amenity sub-collections."
        icon={<FiPlus className="h-4 w-4" />}
      >
        <div className="flex flex-wrap items-center gap-3">
          <Button
            props={{
              type: "button",
              title: "Add Inter. / Exter. Images",
              category: "default",
              action: "add",
              onClick: () => setShowExtImages(true),
            }}
          />
          <Button
            props={{
              type: "button",
              title: "Add More Details",
              category: "default",
              action: "add",
              onClick: () => setShowModal(true),
            }}
          />
          {(exteriorImages?.length > 0 || collection?.length > 0) && (
            <span className="inline-flex items-center gap-1 rounded-full bg-emerald-50 px-2.5 py-1 text-xs font-semibold text-emerald-700">
              <FiStar className="h-3 w-3" />
              {exteriorImages?.length || 0} images · {collection?.length || 0}{" "}
              extras
            </span>
          )}
        </div>
      </AddSection>

      <DescriptionSection
        description={description}
        setDescription={setDescription}
        hashtags={hashtags}
        setHashtags={setHashtags}
        onGenerate={() => setShowDescriptionModal(true)}
      />
    </AddPageShell>
  );
};

export default Add;
